import { Expose } from 'class-transformer';

export class SurveyOriginAnalyticsPayload {
  @Expose({ name: 'originLink' })
  origin_link!: string;

  @Expose({ name: 'originGmbAddress' })
  origin_gmb_address!: string;
}
